import { napsaApi } from 'Api/napsa';
import { SideDrawerWrapper } from 'components/Global';
import { TablePagination, TableSorter } from 'interfaces/global.interface';
import { useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import AddNapsaSideDrawer from './AddNapsaSideDrawer';
import NapsaHeader from './Header';
import HistoryModal from './NapsaHistoryModal';
import NapsaLatestTable from './NapsaTable';
import { NapsaTabProps } from './types';

const NapsaComponent = (props: NapsaTabProps) => {
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [isLoading, setIsLoading] = useState(false);
	const [totalRecords, setTotalRecords] = useState(0);
	const [sortField, setSortField] = useState('');
	const [sortOrder, setSortOrder] = useState('');
	const [drawerAnimation, setDrawerAnimation] = useState<boolean>(false);
	const [isSideDrawerOpen, setIsSideDrawerOpen] = useState<boolean>(false);
	const [latestNapsaDetails, setLatestNapsaDetails] = useState<any>([]);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isHistoryLoading, setIsHistoryLoading] = useState(false);
	const [allNapsaData, setAllNapsaData] = useState<any>([]);

	const tableChangeHandler = (
		pagination: TablePagination,
		filters: any,
		sorter: TableSorter
	) => {
		setTotalRecords(pagination.total);
		setCurrentPage(pagination.current);
		setPageSize(pagination.pageSize);
		let order = '';
		if (sorter?.order === 'ascend') {
			order = 'asc';
		} else if (sorter?.order) {
			order = 'desc';
		}
		setSortOrder(order);
		setSortField(sorter.field);
	};

	const sidebarDrawerOpen = () => {
		setDrawerAnimation(true);
		setIsSideDrawerOpen(true);
	};

	const removeDrawerFromDom = () => {
		setIsSideDrawerOpen(false);
	};

	const closeDrawerByAnimation = () => {
		setDrawerAnimation(false);
	};
	const showModal = () => {
		setIsModalOpen(true);
	};
	const closeModal = () => {
		setIsModalOpen(false);
	};

	const refreshNapsa = () => {
		setCurrentPage(1);
		fetchLatestNapsaData();
		fetchAllNapsaDetails();
	};

	const fetchLatestNapsaData = async () => {
		try {
			setIsLoading(true);
			const napsaData = await napsaApi.getLatestNapsa();
			setLatestNapsaDetails(napsaData.data.data);
		} catch (error: any) {
			if (error.response?.data?.error?.code !== 103) {
				toastText(
					'Something went wrong in fetching napsa Details',
					'error'
				);
			} else {
				toastText(error.response?.data?.error?.message, 'error');
			}
		} finally {
			setIsLoading(false);
		}
	};
	const fetchAllNapsaDetails = async () => {
		try {
			const query = {
				page: currentPage,
				sortBy: sortField,
				sortOrder: sortOrder,
				pageSize: pageSize,
			};

			setIsHistoryLoading(true);
			const allData = await napsaApi.getNapsaHistory(query);
			const historyDetails = allData.data.data;

			setAllNapsaData(historyDetails);

			setTotalRecords(allData.data.total);
		} catch (error: any) {
			if (error.response?.data?.error?.code !== 103) {
				toastText('Something went wrong in fetching history', 'error');
			} else {
				toastText(error.response?.data?.error?.message, 'error');
			}
		} finally {
			setIsHistoryLoading(false);
		}
	};
	useEffect(() => {
		fetchLatestNapsaData();
	}, []);

	useEffect(() => {
		fetchAllNapsaDetails();
	}, [pageSize, currentPage, sortOrder, sortField]);

	return (
		<>
			<div>
				<NapsaHeader
					sidebarDrawerOpen={sidebarDrawerOpen}
					isLoading={isLoading}
					fetchLatestNapsaData={refreshNapsa}
				/>
				<NapsaLatestTable
					napsaLatestData={latestNapsaDetails}
					isLoading={isLoading || isHistoryLoading}
					showModal={showModal}
					totalRecords={totalRecords}
				/>
			</div>
			{isSideDrawerOpen && (
				<SideDrawerWrapper
					isOpen={drawerAnimation}
					removeDrawerFromDom={removeDrawerFromDom}
					closeDrawerByAnimation={closeDrawerByAnimation}
					headerTitle="Add NAPSA"
					position="right"
					width="half"
				>
					<AddNapsaSideDrawer
						closeDrawerByAnimation={closeDrawerByAnimation}
						fetchLatestNapsaData={fetchLatestNapsaData}
						fetchAllNapsaDetails={fetchAllNapsaDetails}
					/>
				</SideDrawerWrapper>
			)}
			{isModalOpen && (
				<HistoryModal
					closeModal={closeModal}
					open={isModalOpen}
					totalRecords={totalRecords}
					pageSize={pageSize}
					currentPage={currentPage}
					tableChangeHandler={tableChangeHandler}
					allNapsaData={allNapsaData}
					isLoading={isHistoryLoading}
				/>
			)}
		</>
	);
};

export default NapsaComponent;
